export const timezoneOptions = [
  {
    label: "common.timezones.labels.est",
    value: "America/New_York",
  },
  {
    label: "common.timezones.labels.cst",
    value: "America/Chicago",
  },
  {
    label: "common.timezones.labels.mst",
    value: "America/Denver",
  },
  {
    label: "common.timezones.labels.pst",
    value: "America/Los_Angeles",
  },
  {
    label: "common.timezones.labels.ast",
    value: "America/Anchorage",
  },
  {
    label: "common.timezones.labels.hst",
    value: "Pacific/Honolulu",
  },
] as const;
